import  { ReactNode } from 'react';

interface TitleWithContentProps {
    title: string;
    children?: ReactNode; // Adjusted to accept ReactNode
}

const TitleWithContent = ({ title, children }: TitleWithContentProps) => {
    return (
        <>
            <div style={{
                 paddingLeft: "clamp(.2rem, 6vw, 8rem)",
                 paddingRight: "clamp(.2rem, 6vw, 8rem)",
                 marginTop: "clamp(0.2rem, 6vw, 6rem)",   
            }}
            className="group ">
                <p
                className="title-text-size">{title}</p>
                <div style={{
                    marginBottom: "clamp(0.2rem, 2vw, 2rem)",
                }} className="custom__divider">
                    <h1></h1>
                </div>
                {children} 
            </div>
        </>
    );
};

export default TitleWithContent;
